import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from 'features/auth/store/authStore'
import SetupSignature from 'features/profile/pages/SetupSignature/SetupSignature'
import PaymentContactModal from 'components/Custom/PaymentContactModal/PaymentContactModal'

export default function PrivateRoute() {
  const { token, signature, role, isPaymentContactCompleted, features } =
    useAuth()

  if (token && !signature) {
    return <SetupSignature />
  }

  // Blocking Payment Contact check:
  // If payment_contact feature is active, sellers must complete payment contact
  // before being allowed to view dashboard or any private route (just like signature).
  if (
    token &&
    role === 'seller' &&
    features?.payment_contact &&
    !isPaymentContactCompleted
  ) {
    return <PaymentContactModal isOpen={true} />
  }

  return token ? <Outlet /> : <Navigate to='/login' />
}
